import React from "react";
import "./index.scss"
import newsDetail from "../../constants/news-preview/newsDetaile"
function NewsReader(props) {
    if (!props.news) return null 
    return <div className="reader-container">
        <div className="news-title">{props.news.title}</div>
        <div className="news-header">
            {
                props.news.header.map(item => {
                    return <span className="header-item">{item}</span>
                })
            }
        </div>
        <div className="split-line"></div>
        <div className="news-content">
            {
                props.news.content.map(item => {
                    return <p className="paragraph">{item}</p>
                })
            }
        </div>
        <div className="img-space">
            <img src={props.news.newsImg} className="news-img" />
            <p className="img-desc">{props.news.imgDesc}</p>
        </div>
    </div>
}

export default NewsReader;